import React, { useMemo } from "react";
import { DataGrid } from "devextreme-react";
import { Column, Editing, Lookup, RequiredRule } from "devextreme-react/data-grid";
import "./sitil.css"
import { useDataSource } from "../../../contexts/dataSource";


function MenuTranslation({ menuId }) {

    const { dataSourceAdmin } = useDataSource()

    const handleInitNewRow = React.useCallback((e) => {
        e.data.referenceId = menuId
    }, [menuId]);

    const languages = [
        {
            id: "ddec791a-d71f-4c07-91d7-20e4eea2ad7a",
            name: "Türkçe"
        },
        {
            id: "5a41be5e-0cb9-4a3e-a1a7-0244b53134cc",
            name: "English"
        },
    ]

    const dataSource = useMemo(() => dataSourceAdmin({
        loadUrl: "/api/MenuTranslation/Menu",
        insertUrl: "/api/MenuTranslation/FormData",
        parentId: menuId
    }), [menuId])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <div className="grid-caption">Translation List</div>
                    <DataGrid
                        height={200}
                        width={600}
                        dataSource={dataSource}
                        showBorders={true}
                        onInitNewRow={handleInitNewRow}
                        searchPanel={true}
                        columnAutoWidth={true}
                        errorRowEnabled={false}
                    >
                        <Editing
                            allowAdding={true}
                            allowDeleting={true}
                            allowUpdating={true}

                        />
                        <Column dataField="languageId" caption="Dil" width={125}>
                            <RequiredRule />
                            <Lookup dataSource={languages} valueExpr="id" displayExpr="name" />
                        </Column>
                        <Column dataField="text" caption="Metin" ><RequiredRule /></Column>
                        {/* <Column dataField="referenceId" caption="referansID" /> */}

                    </DataGrid>
                </div>
            </div>
        </React.Fragment>
    )
}

export default MenuTranslation
